module.exports = __webpack_public_path__ + "static/media/subscript.2ce18d1f.svg";